import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import {Box, Button, Divider} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useDiagnosticReportFormModalContext} from '@/patient/context/DiagnosticReportFormModalContext';
import useCanUploadPhotos from '@/patient/hooks/useCanUploadPhotos';
import {useConditions} from '@/patient/hooks/useConditions';
import CompanyLogo from '@/shared/components/layout/LoggedInLayout/Sidebar/CompanyLogo';
import {Menu} from '@/shared/components/layout/LoggedInLayout/Sidebar/Menu';
import {SidebarWrapper} from '@/shared/components/layout/LoggedInLayout/Sidebar/styledComponents';
import InvestigatorManualButton from '@/shared/components/ui/InvestigatorManualButton';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';
import patientMenuItems from './menu';

export default function PatientSidebar({onCloseSidebar}: {onCloseSidebar?: () => void}) {
  const company = useCompany();
  const conditions = useConditions();
  const investigatorManualLinkForPatient = company.investigatorManualLinkForPatient;
  const {t} = useTranslation(['shared/common', 'patient/common', 'shared/medicationRequest']);
  const canUploadPhotos = useCanUploadPhotos();
  const menuItems = patientMenuItems(company, conditions, canUploadPhotos);
  const openDiagnosticReportFormModal = useDiagnosticReportFormModalContext();

  function handleUploadPhotoClick() {
    onCloseSidebar?.();
    openDiagnosticReportFormModal();
  }
  return (
    <SidebarWrapper>
      <Box
        sx={{
          position: 'sticky',
          top: 15
        }}
      >
        <CompanyLogo company={company} />
        <Menu menuItems={menuItems} onCloseSidebar={onCloseSidebar} t={t} />{' '}
        {canUploadPhotos && (
          <Box
            sx={{
              my: 2
            }}
          >
            <Button
              startIcon={<AddAPhotoIcon />}
              fullWidth
              onClick={handleUploadPhotoClick}
              color="primary"
              variant="contained"
              disableElevation
            >
              {t('patient/common:menu.upload')}
            </Button>
          </Box>
        )}
        <Divider sx={{width: '100%'}} />
        <Box
          sx={{
            my: 2
          }}
        >
          {company.isForClinicalTrials && investigatorManualLinkForPatient ? (
            <InvestigatorManualButton href={investigatorManualLinkForPatient} />
          ) : (
            <Button
              startIcon={<SupportAgentIcon />}
              fullWidth
              component="a"
              href="https://legit.health/support-for-patients"
              color="secondary"
              variant="outlined"
              target="_blank"
            >
              {t('shared/common:support.label')}
            </Button>
          )}
        </Box>
      </Box>
    </SidebarWrapper>
  );
}
